import type { IconSvgObject } from './types';

const Infinity02Icon: IconSvgObject = [
  ["path", { d: "M12 12C12 12 10.3569 15 8.7 15C7.04315 15 6 13.6569 6 12C6 10.3431 7.04315 9 8.7 9C10.3569 9 12 12 12 12ZM12 12C12 12 13.6431 15 15.3 15C16.9569 15 18 13.6569 18 12C18 10.3431 16.9569 9 15.3 9C13.6431 9 12 12 12 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 3L20 3.00001C21.1046 3.00002 22 3.89545 22 5.00001V19C22 20.1046 21.1046 21 20 21H18.5M5.5 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Infinity02Icon;
